import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Banner.module.css';
import BackgroundShadow from '../shared/BackgroundShadow';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import image from './images/Group.png';

const Banner: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);
    return (
        <div className={styles.container}>
            <BackgroundShadow />
            <div className={styles.leftContainer}>
                <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                    Creativity
                </OptimizedMotionH1>
                <OptimizedMotionP className={styles.description} type="slide-down" delay={0.4}>
                    Creativity is the spark that transforms ideas into impactful content—driving
                    innovation, engagement, and authentic brand expression.
                </OptimizedMotionP>
            </div>
            <div className={styles.rightContainer}>
                <img src={image} alt="banner" className={styles.image} />
            </div>
        </div>
    );
};

export default Banner;
